import React, { useState } from "react";
import {
    getLastMonthLeads,
    getLastWeekLeads,
    getTodayLeads,
    getCustomDateLeads,
    getWeekCount,
    getMonthCount,
    search,
} from "../../../helpers/LeadsHelpers";
import OptionsBar from "./OptionsBar";
import TablaLeads from "./TablaLeads";
import { exportTableToCSV } from "../../../helpers/CSVhelpers";

const FILTERS_CONSTS = {
    ALL: "ALL",
    TODAY: "TODAY",
    WEEK: "WEEK",
    MONTH: "MONTH",
    SELECT: "SELECT",
};

const styles = {
    reporteContainer: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        marginTop: "4rem",
    },
    stats: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        padding: "6px",
        borderRadius: "4px",
        backgroundColor: "#f9f9f9",
    },
    tableContainer: {
        marginTop: "4rem",
        marginBottom: "3rem",
    },
};

const CampaniaStats = ({ leads }) => {
    const [currentLeads, setCurrentLeads] = useState(leads);
    const [searchLeads, setSearchLeads] = useState(null);

    function handleFilterChange(filter, dates) {
        switch (filter) {
            case FILTERS_CONSTS.TODAY:
                return setCurrentLeads(getTodayLeads(leads));
            case FILTERS_CONSTS.WEEK:
                return setCurrentLeads(getLastWeekLeads(leads));
            case FILTERS_CONSTS.MONTH:
                return setCurrentLeads(getLastMonthLeads(leads));
            case FILTERS_CONSTS.SELECT:
                return setCurrentLeads(getCustomDateLeads(leads, dates));
            case FILTERS_CONSTS.ALL:
                return setCurrentLeads(leads);
            default:
                return;
        }
    }

    function handleSearch(e) {
        const query = e.target.value;
        if (e.key === "Enter" || e.keyCode === 13) {
            if (query.length > 3) {
                setSearchLeads(search(query, currentLeads));
            }
        }
        if (e.key === "Backspace" || e.keyCode === 8) {
            if (query.length === 0) {
                setSearchLeads(null);
            }
        }
    }

    function generateCSV() {
        const leads = searchLeads || currentLeads;
        exportTableToCSV(leads, "leads.csv");
    }

    return (
        <div style={styles.reporteContainer}>
            <div style={styles.stats}>
                <span>
                    <b>LEADS TOTALES:</b> {leads.length}
                </span>
                <span>
                    <b>ULT SEMANA:</b> {getWeekCount(leads)}
                </span>
                <span>
                    <b>ULT MES:</b> {getMonthCount(leads)}
                </span>
            </div>

            <OptionsBar
                handleChange={handleFilterChange}
                filterConsts={FILTERS_CONSTS}
                handleSearch={handleSearch}
                generateCSV={generateCSV}
            />

            <div style={styles.tableContainer}>
                <TablaLeads leads={searchLeads || currentLeads} />
            </div>
        </div>
    );
};

export default CampaniaStats;



// WEBPACK FOOTER //
// ./src/scenes/reportes/components/CampaniaStats.js